import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class StoreContextService {

    public storeChanged: Subject<any> = new Subject<any>();

    constructor(
        public cookieService: CookieService
    ) {}

    emitStoreChanged(input) {
        this.storeChanged.next(input);
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/store-context.service.ts